
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/[rootKey]/partnership/cashlesscard",
      function () {
        return require("private-next-pages/[rootKey]/partnership/cashlesscard/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/[rootKey]/partnership/cashlesscard"])
      });
    }
  